module.exports = __webpack_public_path__ + "img/icon-slider-arrow-black.a1670b1a.png";